import React, {Component, Fragment} from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";

class VotesByHour extends Component {

  render() {

      const data = {
        labels: ["Votos electrónicos por hora"],
        datasets: [
          {
            label: "Votos electrónicos ",
            backgroundColor: "#e7501e",
            data: this.props.votes,

          }
        ]
      };

      const now = new Date().getTime();

      const chartOptions = {
        scales: {
          xAxes: [
            {
              type: "time",
              time: {
                parser: "x",
                unit: "hour",
                min: this.props.votes[0].x - 1800000,
                max:
                  Math.min(
                    now - (now % 3600000),
                    this.props.votes[this.props.votes.length - 1].x
                  ) + 1800000
              },
              distribution: "series"
            }
          ],
          yAxes: [
            {
              ticks: {
                min: 0
              },
              distribution: "series"
            }
          ]
        }
      };

      return (

            <Fragment>
              <div className="row justify-content-center EvColor text-white">
                <div className="col-12 col-sm-11 col-md-9 col-lg-7  p-3">
                  <h4>Votos electrónicos por hora</h4>
                </div>
              </div>
              <br/>
              <div className="row justify-content-center ">
                <div className="col-12 col-sm-11 col-md-9 col-lg-7 EvColorGrisLight">
                  <Bar data={data} options={chartOptions} />
                </div>
              </div>
            </Fragment>
      );

  }
}

export default VotesByHour;